import TagList from './TagList';
export { type TagItemProps, type Tag, type TagProps } from './TagList.d'

export default TagList;
